// DevExtreme localization plugin
// This plugin provides basic DevExtreme localization support

export function setupDevExtremeLocales(i18n) {
  // Check if DevExtreme is available
  if (typeof window === 'undefined' || !window.DevExpress) {
    console.warn('DevExtreme not found, skipping localization setup')
    return
  }

  try {
    // Configure DevExtreme with current locale
    window.DevExpress.config({
      defaultLocale: i18n.locale
    })

    // Watch for locale changes
    i18n.$watch('locale', (newLocale) => {
      if (window.DevExpress) {
        window.DevExpress.config({
          defaultLocale: newLocale
        })
      }
    })

    console.log('DevExtreme localization configured successfully')
  } catch (error) {
    console.error('Failed to setup DevExtreme localization:', error)
  }
}

// Function to get DevExtreme locale data
export function getDevExtremeLocaleData(locale) {
  // Return the locale string - DevExtreme handles the rest internally
  return locale
}

// Function to set DevExtreme locale manually
export function setDevExtremeLocale(locale) {
  if (typeof window !== 'undefined' && window.DevExpress) {
    try {
      window.DevExpress.config({
        defaultLocale: locale
      })
      return true
    } catch (error) {
      console.error('Failed to set DevExtreme locale:', error)
      return false
    }
  }
  return false
}